export default "https://assets.egbcdn.net/assets/packs/_/images/stories/pig-91427cacb81b3e6991e02c46acec25ed.png";